export const FLOATING_PANEL_MIN_WIDTH = 360;

export const FLOATING_PANEL_MIN_HEIGHT = 240;

/**
 * Keeps the panel strictly smaller than the viewport. cdkDragBoundary inverts
 * its clamp once the dragged element exceeds the boundary, which would let the
 * header (and so the drag handle and close button) be dragged out of view.
 */
export const FLOATING_PANEL_VIEWPORT_MARGIN = 8;
